Ext.define('SA.view.RenameDatasetErrorWindow', {
    alias: 'widget.rename-dataset-error-window',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-rename-dataset-error-window',
    includeHeader: false,
    includeOkBtn: true,

    getBodyItems() {
        var currentName = Ext.htmlEncode(this.currentName),
            proposedName = Ext.htmlEncode(this.proposedName);

        return {
            xtype: 'component',
            cls: 'sa-rename-dataset-error-window-body-content',

            html: [
                '<svg><use href="#sa-icon-warning"></use></svg>',
                '<div>',
                    `<p><strong>The name ‘${proposedName}’ is currently the name of another dataset.</strong></p>`,
                    `<p>To rename your <strong>‘${currentName}’</strong> dataset, please choose a unique name.</p>`,
                '</div>'
            ]
        };
    }
});